import script from "./DetalleJugadorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleJugadorView.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleJugadorView.vue?vue&type=style&index=0&id=e4b32e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4b32e48"]])

export default __exports__